/* eslint-env browser */
import Domodule from 'domodule';
import Ajax from 'bequest';
import { removeClass, addClass, find, fire } from 'domassist';

class Pagination extends Domodule {
  postInit() {
    if (!this.els.loadMore) {
      return;
    }

    this.currentPage = 1;
    this.storyListContainer = this.find('.CardList')[0];
    this.loading = false;
    this.loadingText = this.els.loadMore.dataset.loadingText;
    this.loadedText = this.els.loadMore.textContent.trim();
  }

  updateButton() {
    this.els.loadMore.textContent = this.loading ?
      this.loadingText : this.loadedText;
    this.els.loadMore.disabled = this.loading;
  }

  getQuery() {
    let query = '';
    const dataset = JSON.parse(JSON.stringify(this.els.loadMore.dataset));

    Object.keys(dataset).forEach(data => {
      if (data.indexOf('query') === 0) {
        const property = data.replace('query', '').toLowerCase();
        const value = this.els.loadMore.dataset[data];

        query += `&${property}=${value}`;
      }
    });

    return query;
  }

  loadMore(el, event, data) {
    if (this.loading) {
      return;
    }

    const url = `${data.url}?next=${this.currentPage + 1}${this.getQuery()}`;
    this.loading = true;
    this.updateButton();

    Ajax.request(url, 'GET', (err, resp) => {
      this.loading = false;
      this.updateButton();

      if (err) {
        // TODO: Handle error
        return;
      }

      if (resp.statusCode === 200) {
        this.storyListContainer.innerHTML += resp.data.trim();
        this.currentPage++;
        const lastCall = find('#endStoriesPagination').length;
        const cardList = find('div.CardList-item', this.storyListContainer);
        const modu = cardList.length % 3;
        if (modu === 0 || lastCall === 1) {
          removeClass(cardList, 'hide');
        } else {
          removeClass(cardList.slice(0, (modu * -1)), 'hide');
        }
        if (lastCall) {
          addClass(this.els.loadMore, 'hide');
        }

        find('.Card-header img[data-scroll-image]').forEach(img => {
          img.src = img.dataset.scrollImage;
          img.removeAttribute('data-scroll');
          img.removeAttribute('data-scroll-image');
        });
        fire(window, 'resize');
      }
    });

    event.preventDefault();
  }
}

Domodule.register('Pagination', Pagination);
